import countryMap from './Regions/CountryMap.json';

export const getCountryLink = (countryCode: string) => {
  const country = countryMap.find(
    (item) => item.countryCode?.toLowerCase() === countryCode?.toLowerCase()
  );
  return (
    country?.meetingLink ?? 'https://calendly.com/us-team-2/demo-with-esper'
  );
};
